import { bindable, useView } from 'aurelia-templating';
import { PLATFORM, autoinject } from 'aurelia-framework';

//Load styles
require("./comp-loader.scss");

@autoinject
@useView(PLATFORM.moduleName("./comp-loader.html"))
export class CompLoader {

    @bindable
    public theme: string = "primary";
}
